export default __webpack_public_path__ + "static/media/zelda2.817a396c.png";